import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-300">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-primary-500">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-bold font-heading text-background-50 whitespace-nowrap">
                  快猫视频
                </span>
              </Link>
              <p className="text-sm leading-relaxed text-background-400">
                快猫视频是一款风靡全网的短视频娱乐平台，汇聚搞笑、生活、才艺等多元视频内容，支持一键下载与分享。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/category/gaoxiao" className="text-sm text-background-400 hover:text-primary-400 transition-colors">分类浏览</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">热门分类</h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/gaoxiao" className="text-sm text-background-400 hover:text-primary-400 transition-colors">搞笑视频</Link></li>
                <li><Link to="/category/shenghuo" className="text-sm text-background-400 hover:text-primary-400 transition-colors">生活记录</Link></li>
                <li><Link to="/category/caiyi" className="text-sm text-background-400 hover:text-primary-400 transition-colors">才艺展示</Link></li>
                <li><Link to="/category/meishi" className="text-sm text-background-400 hover:text-primary-400 transition-colors">美食制作</Link></li>
                <li><Link to="/category/youxi" className="text-sm text-background-400 hover:text-primary-400 transition-colors">游戏实况</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-background-400">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>contact@kuaimaovideo.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-888-6666</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-primary-400"></i>
                  <span>北京市朝阳区科技园路188号</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 快猫视频 版权所有 | 京ICP备2024XXXXXXXX号
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-primary-400 transition-colors">用户协议</a>
              <a href="#" className="hover:text-primary-400 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}